import { uid } from "../../helpers";
import { uid as libUID } from "@xbs/lib-state";
export function indentSelectedTasks({ store }) {
    const selected = store.getState().selected;
    let $meta;
    if (selected.length > 1) {
        $meta = { batch: libUID() };
    }
    const batchID = uid();
    store.eachSelected(id => {
        const parent = store.getTask(store.getTask(id).parent);
        if (!parent?.selected) {
            store.in.exec("indent-task", { id, batchID, $meta });
        }
    }, true);
}
//# sourceMappingURL=indent.js.map